module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "contact-item",
    attrs: {
      "id": "contacts-show"
    }
  }, [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": "/contatos/grupos"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('groups.actions.update.title')) + " " + _vm._s(_vm.original_group_name))])]), _c('div', {
    staticClass: "dropdown pull-right"
  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
    staticClass: "btn btn-primary contact-show-actions btn-options dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')))]), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })]) : _vm._e(), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#contacts-manual-picker"
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_vm._v(_vm._s(_vm.$t('general.label.Manually')))])]), _c('li', {
    attrs: {
      "id": "contact-picker",
      "data-toggle": "modal",
      "data-target": "#contacts-picker"
    }
  }, [_c('a', {
    staticClass: "clickable",
    attrs: {
      "id": "open-contact-picker"
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.contactBaseAdd')))])])])])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.groupName')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_group.name),
      expression: "contact_group.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.contact_group.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact_group, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-2 col-md-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "responsible"
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Responsible')))]), _c('user-miniature', {
    attrs: {
      "id": "responsible",
      "user": _vm.contact_group.user,
      "options": {
        first_name: true
      }
    }
  })], 1), _c('div', {
    staticClass: "col-md-2 col-md-offset-1"
  }, [_c('div', {
    staticClass: "number-with-label"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.contacts_count))]), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "upper-label"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.contacts')))]), _c('div', {
    staticClass: "lower-label"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.added')))])]), _c('div', {
    staticClass: "clear"
  })])])]), _c('hr'), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadContacts),
      expression: "loadContacts"
    }],
    staticClass: "group-contacts-list",
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "view_mode": _vm.contactListViewModes().group,
      "origem": _vm.$t('groups.label.Group')
    },
    on: {
      "contact-destroy": _vm.removeFromGroup,
      "contact-update": _vm.updateContact,
      "contact-recipient-update": _vm.updateContactRecipient,
      "filter": _vm.filter
    }
  })], 1), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1), _c('go-to-top'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "wrapper-buttons text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/contatos/grupos"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.current_user.isMonitoringManager()
    },
    on: {
      "click": _vm.saveGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)])]), _c('contact-picker', {
    attrs: {
      "fetch_mode": 'withoutGroup',
      "view_mode": _vm.contactListViewModes().group_picker,
      "user_id": _vm.contact_group.user.id
    },
    on: {
      "contacts-selected": _vm.selectContacts
    }
  }), _c('contact-manual-picker', {
    on: {
      "contact-picker-contacts-added": _vm.addContactsToGroup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59f845ea!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact_groups/edit.vue
// module id = 1133
// module chunks = 1